import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500 md:text-sm">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="inline-flex items-center gap-1.5">
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
          {index < items.length - 1 ? <i className="ri-arrow-right-s-line text-foreground-300"></i> : null}
        </span>
      ))}
    </nav>
  );
}